import { useEffect, useState } from "react";
import fetch from "mibaby-common/util/fetch";
import useMounted from "mibaby-frontend/util/hooks/useMounted";

// Asynchronously load the data required to render a teaser
export default id => {
  const [status, setStatus] = useState();
  const [itemProps, setItemProps] = useState({});
  const mounted = useMounted();

  // fetch and resaolve everytime the id changes.
  useEffect(() => {
    if (!id) {
      setStatus();
      setItemProps({});
    } else {
      setStatus("loading");
      (async () => {
        try {
          const resp = await fetch(`/content_feeds/teaser/${id}`);
          const json = await resp.json();
          if (!mounted.current) {
            // do not update if during fetching the component
            // got unmounted
            return;
          }
          setItemProps(json);
          setStatus("loaded");
        } catch (e) {
          setStatus("error");
        }
      })();
    }
  }, [id]);
  return [status, itemProps];
};
